import clsx from 'clsx';

/**
 * PageSection — canonical full-width section wrapper.
 *
 * Enforces the homepage vertical rhythm (clamp 72–112px) and the 1200px
 * centered container, replacing legacy `.lb-section` / `.lb-section-alt` and
 * per-page inline `padding:'NNpx 0'`.
 *
 * Props:
 *   bg     - "page" (#fff, default) | "tint" (--surface-page) | "dark" (--bg-dark)
 *   tight  - use the tighter --section-pad-tight rhythm
 *   id     - section id (anchor targets)
 */
const BACKGROUNDS = {
  page: '#FFFFFF',
  tint: 'var(--surface-page)',
  dark: 'var(--bg-dark)',
};

export function PageSection({
  children,
  id,
  bg = 'page',
  tight = false,
  className = '',
  containerClassName = '',
  style,
  ...rest
}) {
  return (
    <section
      id={id}
      className={className}
      style={{
        padding: tight ? 'var(--section-pad-tight)' : 'var(--section-pad)',
        background: BACKGROUNDS[bg] || BACKGROUNDS.page,
        ...(id ? { scrollMarginTop: 80 } : null),
        ...style,
      }}
      {...rest}
    >
      <div className={clsx('container', containerClassName)}>{children}</div>
    </section>
  );
}
